import type { ConstValues } from './helpers';

export const ACL_TYPE = {
  ADUNIT_AD_TAG_WRITE: 'adunit.ad_tag.write',
  ADUNIT_CREATE: 'adunit.create',
  ADUNIT_DELETE: 'adunit.delete',
  ADUNIT_READ: 'adunit.read',
  ADUNIT_UPDATE: 'adunit.update',

  ADVERTISER_CREATE: 'advertiser.create',
  ADVERTISER_EXCHANGE_CREDIT_READ: 'advertiser.exchange.credit.read',
  ADVERTISER_EXCHANGE_DEAL_LINEITEM_WRITE: 'advertiser.exchange.deal_lineitem.write',
  ADVERTISER_EXCHANGE_QPS_TARGET_WRITE: 'advertiser.exchange.qps_target.write',
  ADVERTISER_EXCHANGE_SITE_ID_TARGETING_READ: 'advertiser.exchange.site_id_targeting.read',
  ADVERTISER_READ: 'advertiser.read',
  ADVERTISER_UPDATE: 'advertiser.update',

  AD_QUALITY_FEATURE_ENABLED: 'feature.ad_quality.enabled',
  DIRECT_DEALS_VIEW_ENABLED: 'feature.publisher_marketplace_view.enabled',
  XPERT_ENABLED: 'feature.xpert.enabled',
  DEAL_REVENUE_CALCULATOR_ENABLED: 'feature.deal_revenue_calculator.enabled',
  GEO_RADIUS_OVER_LIMIT_ENABLED: 'feature.geo_radius_over_limit.enabled',

  APP_CATEGORY_CREATE: 'appcategory.create',
  APP_CATEGORY_DELETE: 'appcategory.delete',
  APP_CATEGORY_READ: 'appcategory.read',
  APP_CATEGORY_UPDATE: 'appcategory.update',

  BLOCKED_SEATS_CREATE: 'blockedseats.create',
  BLOCKED_SEATS_DELETE: 'blockedseats.delete',
  BLOCKED_SEATS_READ: 'blockedseats.read',
  BLOCKED_SEATS_UPDATE: 'blockedseats.update',

  BRAND_CREATE: 'brand.create',
  BRAND_DELETE: 'brand.delete',
  BRAND_READ: 'brand.read',
  BRAND_UPDATE: 'brand.update',

  BUYER_CREATE: 'buyer.create',
  BUYER_DELETE: 'buyer.delete',
  BUYER_READ: 'buyer.read',
  BUYER_UPDATE: 'buyer.update',

  COMMERCIAL_AGREEMENT_CREATE: 'commercialagreement.create',
  COMMERCIAL_AGREEMENT_DELETE: 'commercialagreement.delete',
  COMMERCIAL_AGREEMENT_READ: 'commercialagreement.read',
  COMMERCIAL_AGREEMENT_UPDATE: 'commercialagreement.update',

  CREATIVE_REVIEW_READ: 'creativereview.read',
  CREATIVE_REVIEW_CREATE: 'creativereview.create',
  CREATIVE_REVIEW_UPDATE: 'creativereview.update',

  CURATED_PACKAGES_VISIBLE_TO_SUBORGS: 'feature.openx_non_oaa_curated_packages_visible_to_suborgs.enabled',

  DEAL_AMAZON_MARKETPLACE_ENABLED: 'pmp.amazon_marketplace_deal.enabled',
  DEAL_CREATE: 'pmp.create',
  DEAL_DELETE: 'pmp.delete',
  DEAL_ENABLE_DV360_INVENTORY_PACKAGE_WRITE: 'pmp.enable_dv360_inventory_package.write',
  DEAL_RBO_CONFIG_ADMIN_READ: 'pmp.rbo_config.admin.read',
  DEAL_RBO_CONFIG_ADMIN_WRITE: 'pmp.rbo_config.admin.write',
  DEAL_RBO_CONFIG_READ: 'pmp.rbo_config.read',
  DEAL_RBO_CONFIG_WRITE: 'pmp.rbo_config.write',
  DEAL_IS_PUB_VISIBLE_READ: 'pmp.is_pub_visible.read',
  DEAL_IS_PUB_VISIBLE_WRITE: 'pmp.is_pub_visible.write',
  DEAL_READ: 'pmp.read',
  DEAL_UPDATE: 'pmp.update',

  DEAL_AD_CATEGORY_PROPOSAL_CREATE: 'deal_ad_category_proposal.create',
  DEAL_AD_CATEGORY_PROPOSAL_READ: 'deal_ad_category_proposal.read',
  DEAL_AD_CATEGORY_PROPOSAL_UPDATE: 'deal_ad_category_proposal.update',

  DMP_SOURCES_READ: 'dmp.read',

  DOMAIN_CREATE: 'domain.create',
  DOMAIN_DELETE: 'domain.delete',
  DOMAIN_READ: 'domain.read',
  DOMAIN_UPDATE: 'domain.update',

  DV360_INVENTORY_LIST_READ: 'dv360_inventory_list.read',
  DV360_INVENTORY_LIST_WRITE: 'dv360_inventory_list.write',

  EXT_INVENTORY_MAP_READ: 'internal.ext_inventory_map.read',
  EXT_INVENTORY_MAP_WRITE: 'internal.ext_inventory_map.write',

  FEATURE_PACKAGE_CURATOR: 'feature.package_curator.enabled',

  FEE_CREATE: 'fee.create',
  FEE_DELETE: 'fee.delete',
  FEE_READ: 'fee.read',
  FEE_UPDATE: 'fee.update',

  FEE_SCHEDULE_CREATE: 'feeschedule.create',
  FEE_SCHEDULE_DELETE: 'feeschedule.delete',
  FEE_SCHEDULE_READ: 'feeschedule.read',
  FEE_SCHEDULE_UPDATE: 'feeschedule.update',

  FLOORRULE_CREATE: 'floorrule.create',
  FLOORRULE_DELETE: 'floorrule.delete',
  FLOORRULE_READ: 'floorrule.read',
  FLOORRULE_UPDATE: 'floorrule.update',

  INTERNAL_FIELD_READ: 'internal.field.read',
  INTERNAL_FIELD_WRITE: 'internal.field.write',

  LOOKALIKE_SEGMENTS_ENABLED: 'feature.lookalike_segments.enabled',
  RESULTS_ENABLED: 'feature.results.enabled',
  AI_INVENTORY_DISCOVERY_ENABLED: 'feature.ai_enabled_inventory_discovery.enabled',
  AQUA_ENABLED: 'feature.aqua.enabled',

  LINEITEM_CREATE: 'lineitem.create',
  LINEITEM_DELETE: 'lineitem.delete',
  LINEITEM_READ: 'lineitem.read',
  LINEITEM_UPDATE: 'lineitem.update',

  MARKET_OPERATOR_SEARCH: 'ssp.market_operator_instance.enabled',

  METACATEGORY_CREATE: 'metacategory.create',
  METACATEGORY_DELETE: 'metacategory.delete',
  METACATEGORY_READ: 'metacategory.read',
  METACATEGORY_UPDATE: 'metacategory.update',

  NETWORK_CREATE: 'network.create',
  NETWORK_READ: 'network.read',
  NETWORK_UPDATE: 'network.update',

  OPTIMIZATION_CREATE: 'optimization.create',
  OPTIMIZATION_DELETE: 'optimization.delete',
  OPTIMIZATION_READ: 'optimization.read',
  OPTIMIZATION_SALES_CHANNELS_WRITE: 'optimization.sales_channels.write',
  OPTIMIZATION_UPDATE: 'optimization.update',

  ORDER_CREATE: 'bidder_order.create',
  ORDER_READ: 'bidder_order.read',
  ORDER_UPDATE: 'bidder_order.update',
  ORDER_DELETE: 'bidder_order.delete',

  PACKAGE_CREATE: 'package.create',
  PACKAGE_DELETE: 'package.delete',
  PACKAGE_READ: 'package.read',
  PACKAGE_UPDATE: 'package.update',

  PARTNER_READ: 'partner.read',

  PIXEL_CREATE: 'pixel.create',
  PIXEL_DELETE: 'pixel.delete',
  PIXEL_READ: 'pixel.read',
  PIXEL_UPDATE: 'pixel.update',

  PUBLISHER_CREATE: 'publisher.create',
  PUBLISHER_DELETE: 'publisher.delete',
  PUBLISHER_READ: 'publisher.read',
  PUBLISHER_UPDATE: 'publisher.update',

  RECONCILIATION_PARTNER_CREATE: 'reconciliationpartner.create',
  RECONCILIATION_PARTNER_DELETE: 'reconciliationpartner.delete',
  RECONCILIATION_PARTNER_READ: 'reconciliationpartner.read',
  RECONCILIATION_PARTNER_UPDATE: 'reconciliationpartner.update',

  ROOT_WORKAS_ANYINSTANCE: 'root.workas.anyinstance',

  SEAT_CREATE: 'seat.create',
  SEAT_DELETE: 'seat.delete',
  SEAT_READ: 'seat.read',
  SEAT_UPDATE: 'seat.update',

  SEGMENT_CREATE: 'segment.create',
  SEGMENT_DELETE: 'segment.delete',
  SEGMENT_READ: 'segment.read',
  SEGMENT_UPDATE: 'segment.update',

  SEGMENT_RETARGETING_CREATE: 'segment.retargeting.create',
  SEGMENT_RETARGETING_DELETE: 'segment.retargeting.delete',
  SEGMENT_RETARGETING_READ: 'segment.retargeting.read',
  SEGMENT_RETARGETING_UPDATE: 'segment.retargeting.update',

  SITE_CREATE: 'site.create',
  SITE_DELETE: 'site.delete',
  SITE_MAX_NUM_OF_ALLOWED_BIDS_READ: 'site.max_num_of_allowed_bids.read',
  SITE_READ: 'site.read',
  SITE_UPDATE: 'site.update',

  SIGNAL_CREATE: 'signal.create',
  SIGNAL_DELETE: 'signal.delete',
  SIGNAL_READ: 'signal.read',
  SIGNAL_UPDATE: 'signal.update',

  THIRD_PARTY_FEES_PLATFORM_SHARE_READ: 'third_party_fees.platform_share.read',
  THIRD_PARTY_FEES_PLATFORM_SHARE_WRITE: 'third_party_fees.platform_share.write',
  THIRD_PARTY_FEES_READ: 'third_party_fees.read',
  THIRD_PARTY_FEES_WRITE: 'third_party_fees.write',

  USER_CREATE: 'user.create',
  USER_DELETE: 'user.delete',
  USER_READ: 'user.read',
  USER_ROLE_WRITE: 'user.role.write',
  USER_SELF_ROLE_WRITE: 'user.self.role.write',
  USER_SELF_UPDATE: 'user.self.update',
  USER_UPDATE: 'user.update',
} as const;
export type AclType = ConstValues<typeof ACL_TYPE>;
